import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import TextField from '@mui/material/TextField';
import { useNavigate, useParams } from 'react-router-dom';
import FormPageHeader from '../utilities/FormPageHeader';
import { FormControl, Stack, Typography } from '@mui/material';
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import { checkBlankSpace, checkSpecialChar } from '../utilities/FormValidation';


const ShippingTypeForm = () => {

    const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.shippingTypes}`;
    const addUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.shippingType}/addShippingType`;

    const [tabValue, setTabValue] = useState(0);
    const params = useParams();
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const [validError, setValidError] = useState({});
    const [checksubmit, setCheckSubmit] = useState(false);
    const [shippingCode, setShippingCode] = useState("");
    const [shippingMethodName, setShippingMethodName] = useState("");
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [hideDelete, setHideDelete] = useState(true)
    const [saveDisable, setSaveDisable] = useState(true)
    const [editData, setEditData] = useState();

    const handleSubmit = async () => {
        setCheckSubmit(true);
        let model = {
            code: shippingCode ,
            shippingMethodName: shippingMethodName,
        };

        try {
            if (params.id) {
                if (shippingCode && shippingMethodName &&
                    !validError.shippingCode && !validError.shippingMethodName) {
                    await OAuthService.updateData(url, params.id, model);
                    setSuccessMsg("Data Updated Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/shippingType')},800);
                }
            } else {
                if (shippingCode && shippingMethodName &&
                    !validError.shippingCode && !validError.shippingMethodName) {
                    await OAuthService.addData(addUrl, model);
                    setSuccessMsg("Data saved Successfully")
                    setSnackState(true);
                    setTimeout(() => { navigate('/shippingType')},800);
                }
            }

        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }
    }

    /**
        * Tab Change
    */
    function handleTabChange(event, value) {
        setTabValue(value);
    }

    const getShippingType = async () => {
        try {
            const result = await OAuthService.getEditData(url, params.id);
            const ShippingType = result.data;
            setShippingCode(ShippingType.code);
            setShippingMethodName(ShippingType.shippingMethodName);
            setEditData(ShippingType);
        } catch (error) {
            setError(error?.response?.data?.errorMessage || error.message)
        }
    }

    useEffect(() => {
        if (params.id) {
            getShippingType();
            setHideDelete(false)
        }
    }, []);

    const handleDelete = async () => {
        try {
            if (params.id) {
                await OAuthService.deleteData(url, params.id);
                setSuccessMsg("Data deleted Successfully")
                setSnackState(true);
            }
        } catch (error) {
            console.log('error', error)
            setError(error?.response?.data?.errorMessage || error.message)
            return;
        }
        setTimeout(() => { navigate('/shippingType')},800);
    }

    const handleChangeShippingMethod =(e)=>{
        setShippingMethodName(e.target.value);
        setValidError({...validError, shippingName: checkSpecialChar(e.target.value)})
    }

    const handleCancel = () => {
        navigate('/shippingType')
    }

    useEffect(() => {
        if (shippingMethodName.trim() && shippingCode && !validError.shippingCode && !validError.shippingName) {
            if(editData){
                if(shippingMethodName !== editData.shippingMethodName || shippingCode !== editData.shippingCode){
                    setSaveDisable(false);
                }else{
                    setSaveDisable(true);
                }                
            }else{                
                setSaveDisable(false);
            }
        } else {
            setSaveDisable(true);
        }
    },[shippingMethodName,shippingCode,validError]);

    return (
        <div className="w-full overflow-scroll">
            <FormPageHeader
                componentName="ShippingType"
                handleDelete={handleDelete}
                handleSubmit={handleSubmit}
                breadCrumbSeperator=">"
                currentPage={params.id ? "Update ShippingType" : "Add ShippingType"}
                parentBreadcrumbData={[{ pageName: 'ShippingType List', pageLink: '/shippingType' }]}
                error={error}                
                successMsg={successMsg}
                snackState={snackState}
                hideDelete={hideDelete}
                handleCancel={handleCancel}
                saveDisable={saveDisable}
            >
                <Tabs
                    value={tabValue}
                    textColor='inherit'
                    onChange={handleTabChange}
                    indicatorColor="secondary"
                    sx={{ color: "yellow" }}
                    variant="scrollable"
                    scrollButtons="auto"
                    classes={{ root: 'w-full border-b-1' }}
                >
                    <Tab label="General" sx={{ color: 'text.secondary', '&.Mui-selected': { color: 'text.primary' } }} />
                </Tabs>
            </FormPageHeader>
            <div className="p-16 sm:p-24 max-w-3xl">
                <FormControl
                    // ref={formRef}
                    className="flex flex-col justify-center"
                >
                    <div className={tabValue !== 0 ? 'hidden' : ''}>
                    <Stack className="mb-16">
                            <label>*Shipping Code</label>
                            <TextField
                                type="text"
                                name="shippingCode"
                                required
                                value={shippingCode}
                                error={(checksubmit && !shippingCode) || validError.shippingCode ? true : false}
                                helperText={(checksubmit && !shippingCode) ? "This field is required" : validError.shippingCode}
                                onChange={(e) => {setShippingCode(e.target.value.toUpperCase()); setValidError({...validError, shippingCode: checkSpecialChar(e.target.value) || checkBlankSpace(e.target.value)})}}
                                variant="outlined"
                            />
                        </Stack>
                        <Stack className="mb-16">
                            <label>*Shipping Type</label>
                            <TextField
                                type="text"
                                name="shippingMethodName"
                                value={shippingMethodName}
                                error={(checksubmit && !shippingMethodName) || validError.shippingName ? true : false}
                                helperText={(checksubmit && !shippingMethodName) ? "This field is required" : validError.shippingName}
                                onChange={handleChangeShippingMethod}
                                className="select"
                            />
                            <Typography className="text-[#f44336] text-sm ml-14">{(checksubmit && !shippingMethodName) ? "This field is required" : validError.shippingMethodName}</Typography>
                        </Stack>
                        
                    </div>
                </FormControl>
            </div>
        </div>
    )
}

export default ShippingTypeForm